module.exports = __webpack_public_path__ + "img/with-border.0fe5f2e0.png";